import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=0bb78713&scoped=true"
import script from "./AccountForm.vue?vue&type=script&lang=ts"
export * from "./AccountForm.vue?vue&type=script&lang=ts"
import style0 from "./AccountForm.vue?vue&type=style&index=0&id=0bb78713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb78713",
  null
  
)

export default component.exports